import { enterSpace } from '../../app/actions/spaces/EnterSpaceAction';
import { requestSpaceContents } from '../../app/actions/spaces/RequestSpaceContentsActions';
import { updateBreadcrumbs } from '../../app/actions/UpdateBreadcrumbsAction';
import { appStore } from '../../app/AppStore';
import { BackgroundJobsSpaceOwnProps } from '../../app/spaces/BackgroundJobsSpace/BackgroundJobsSpace';
import { addUrlWatchersToScopeForExplorer } from '../../app/spaces/Explorer/ExplorerUrlBindings';
import { setURLParametersOrDefaultsForEnteringSpaceAndFetchContent } from '../../app/spaces/SpaceConfig/SiteSpaceConfigHelper';
import { SpaceItemForNonEntitySpace } from '../../app/state/SpaceInfo';
import { getQueryStringServiceFromAngular } from '../../common/react/QueryString';
import { AngularContextFactory } from '../factories/AngularContextFactory';
import { FeatureFlags } from '../FeatureFlags';
import { Module } from '../Module';
import { BrowserTitleService } from '../services/BrowserTitleService';
import { Telemetry } from '../services/TelemetryService';

export interface IBackgroundJobsScope extends ng.IScope {
  backgroundJobSpaceProps: BackgroundJobsSpaceOwnProps;
}

export class BackgroundJobsCtrl {

  public static $inject = [
    '$location',
    '$scope',
    'BrowserTitleService',
    'TelemetryService',
    'AngularContextFactory',
  ];

  private currentPath: string;

  constructor(
    $location: ng.ILocationService,
    $scope: IBackgroundJobsScope,
    browserTitleService: BrowserTitleService,
    telemetryService: Telemetry,
    angularContextFactory: AngularContextFactory,
  ) {
    browserTitleService.setTitleWithPlace({ translatablePlaceName: 'backgroundJobs' });

    const angularContext = angularContextFactory.create($scope);
    $scope.backgroundJobSpaceProps = {
      telemetry: telemetryService,
      angularContext
    };


    appStore.dispatch(enterSpace({
      item: SpaceItemForNonEntitySpace,
      spaceType: 'backgroundJobs',
      subspaceName: undefined,
    }));

    appStore.dispatch(updateBreadcrumbs([]));

    const queryString = getQueryStringServiceFromAngular($location);
    this.currentPath = $location.path();
    const getPath = () => {
      return this.currentPath;
    };

    // need to reset all filters and sorts when entering the space
    setURLParametersOrDefaultsForEnteringSpaceAndFetchContent(appStore, $location);
    addUrlWatchersToScopeForExplorer({ $scope, $location, queryString, store: appStore, getPreviousPath: getPath });

    appStore.dispatch(requestSpaceContents());
  }
}

Module.instance().controller('BackgroundJobsCtrl', BackgroundJobsCtrl);
